<main id="content-page">
    <div class="container main-panel">
        <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12">
                <div  class="article-inner-container" style="margin-right: 10px; margin-left: 10px">
                    <div id="helpVideo">
                        <div id="helpVideo" class="embedded-video">
                            <iframe id="PLAYER1" webkitallowfullscreen="" mozallowfullscreen="" allow="autoplay; fullscreen" allowfullscreen frameborder="0" src="//player.vimeo.com/video/370068625?api=1&player_id=PLAYER1" width="640" height="360" class="note-video-clip">
                            </iframe>
                        </div>
                        <br />                       
                    </div>
                </div>               
            </div>
        </div>
    </div>
</main>